import {
  getDietaryIngredients,
  useCustomerDietaryRestrictions,
} from '@hungryroot/dietary-restrictions';
import { useCustomerPeriodicities } from '@hungryroot/periodicities';
import { usePairing } from '../../../api/v2/pairings/[id]/get/get-pairing';
import { type IngredientViewModel } from '../../../components/Ingredient/Ingredient';
import { containsNeverItem } from './useIngredientContainsNeverPeriodicity';
export type IngredientDetails = Record<number, IngredientViewModel>;

export const useIngredientDetails = (
  id: number,
  options?: {
    enabled: boolean;
    outOfStockOptions?: {
      inventory_date: string;
      origin: number;
    };
  }
) => {
  const { data: dietaryRestrictionsData } = useCustomerDietaryRestrictions();
  const { data: periodicityData } = useCustomerPeriodicities();
  const { data } = usePairing(id, options);

  if (!data && (!periodicityData || !dietaryRestrictionsData)) {
    return {};
  }

  // API returns ingredient in a different order after you "never" an item
  // so we need to map the ingredient to the correct one
  const ingredientDetails: IngredientDetails =
    data?.ingredients?.reduce((acc, ingredient) => {
      return {
        ...acc,
        [ingredient.id]: {
          ...ingredient,
          dietaryIngredients: getDietaryIngredients(
            ingredient.tags,
            dietaryRestrictionsData?.dietary_restrictions || []
          ),
          containsNeverItem: containsNeverItem(
            [ingredient],
            periodicityData?.results || []
          ),
        },
      };
    }, {}) || {};

  return ingredientDetails;
};
